"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleInfo = exports.CollapsibleContent = void 0;
const react_1 = __importDefault(require("react"));
const react_collapsible_1 = require("@radix-ui/react-collapsible");
const __1 = require("../..");
const CollapsibleInfo_styles_1 = require("./CollapsibleInfo.styles");
/**
 * @deprecated please use <Ds.CollapsibleInfo.Content> instead
 */
exports.CollapsibleContent = react_1.default.forwardRef(({ children, animated }, forwardedRef) => {
    return (react_1.default.createElement(CollapsibleInfo_styles_1.StyledContent, { ref: forwardedRef, "$animated": animated }, children));
});
/**
 * @deprecated please use <Ds.CollapsibleInfo> instead
 */
const CollapsibleInfo = ({ title, children, animated, onToggle, }) => {
    const [isOpen, setIsOpen] = react_1.default.useState(false);
    const onOpenChange = (open) => {
        setIsOpen(open);
        onToggle && onToggle(open);
    };
    return (react_1.default.createElement(react_collapsible_1.Root, { open: isOpen, onOpenChange: onOpenChange },
        react_1.default.createElement(CollapsibleInfo_styles_1.StyledCollapsibleTrigger, null,
            react_1.default.createElement(__1.Icon, { name: "Arrow", size: 3, colour: "blue", rotation: isOpen ? "down" : "right" }),
            react_1.default.createElement(CollapsibleInfo_styles_1.StyledCollapsibleTriggerText, null, title)),
        react_1.default.createElement(exports.CollapsibleContent, { animated: animated }, children)));
};
exports.CollapsibleInfo = CollapsibleInfo;
//# sourceMappingURL=CollapsibleInfo.js.map